import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-trading-dark text-slate-300 font-body selection:bg-trading-gold/30 selection:text-white" data-id="element-0">
      {/* Top Navigation Bar (Minimal) */}
      <nav className="fixed top-0 w-full z-50 bg-trading-dark/80 backdrop-blur-md border-b border-white/5" data-id="element-1">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-2">
          <div className="font-heading font-bold text-xl text-white tracking-wider" data-id="element-3">
            NASDAQ<span className="text-trading-gold" data-id="element-4">PRO</span>
          </div>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-sm font-heading uppercase tracking-wider text-trading-gold hover:text-trading-amber transition-colors" data-id="element-5">
            Obtener Acceso
          </button>
        </div>
      </nav>

      <main data-id="element-6">
        <HeroSection data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <DeliverablesSection data-id="element-10" />
        <AudienceSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <PricingSection data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}